export function randNum (min, max) {
  return (Math.random() * (max - min)) + min
}

export function randInt (min, max) {
  return Math.floor(randNum(min, max))
}




// WEBPACK FOOTER //
// ./src/lib/randutils.js